import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../App.css'


const Book = () => {
    return (
    <>
            <div className='Row'>
            <div className='Col1'></div>
            <div className='Col2'>
                <div className='empty'></div>
            <Footer />
            </div>

            </div>
    </>
    );
}

export default Book;